import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import {Zoom} from 'react-awesome-reveal';
import './MarketMenu.css';
import ClipLoader from "react-spinners/ClipLoader";
import ServingsDropdown from "./ServingsDropdown";

const MarketMenuItem = ({item, onAddToBasket, catHandle}) => {

  const [fillAddBsk, setFillAddBsk] = useState(false)
  const [fillAddBskSml, setFillAddBskSml] = useState(false)
  const [isLoading, setIsLoading] = useState(true);
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);

  useEffect(() => {
    if (item) {
      if (item.variants && item.variants.edges.length > 0) {
        // Capture all variants in a simplified format
        const allVariants = item.variants.edges.map(edge => ({
          price: parseFloat(edge.node.price.amount),
          servings: edge.node.selectedOptions[0].value, // Assuming "Servings" is always the first option
          id: edge.node.id // Keep track of the variant ID for future use
        }));
        setVariants(allVariants);
        setSelectedVariant(allVariants[0]); // Set the first variant as selected initially
      }
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [item]);

  // Function to handle variant selection from dropdown
  const handleVariantChange = (selectedVariantId) => {
    const selected = variants.find(variant => variant.id === selectedVariantId); // Find selected variant using the id
    console.log(selected); // Log the selected variant
    setSelectedVariant(selected); // Update selected variant
  };



const override = {
    display: "flex",
    borderWidth: '5px',
    height: '50px',
    width: '50px',
    position:'absolute',
    left:'calc(50% - 25px)',
    top: 'calc(40%)',
    bottom:'45px',
    zIndex:'0'
};

const overrideSmall = {
    display: "flex",
    borderWidth: '3.5px',
    height: '30px',
    width: '30px',
    position:'absolute',
    left:'calc(50% - 15px)',
    top: 'calc(50% - 15px)',
    bottom:'45px',
    zIndex:'2'
};

const overrideSmaller = {
    display: "flex",
    borderWidth: '3px',
    height: '22px',
    width: '22px',
    position:'absolute',
    left:'calc(50% - 11px)',
    top: 'calc(50% - 11px)',
    bottom:'45px',
    zIndex:'2'
};

const overrideSmallest = {
    display: "flex",
    borderWidth: '2.5px',
    height: '18px',
    width: '18px',
    left:'calc(50% - 9px)',
    top: 'calc(50% - 9px)',
    bottom:'45px',
    zIndex:'2'
};

const getImageUrl = (item) => {
    return item.images?.edges?.[0]?.node?.src || "../../images/category_default.png"; // Use a default image if no URL is found
};

let navigate = useNavigate();

  return (
    <Zoom triggerOnce={true} className='zoom-container'>
        <li className='menu_item_container'>
              <button className='open_modal_sml' onClick={() => {
                  window.scroll(0, 0);
                  navigate('/market/' + catHandle + '/' + item.handle)
              }}></button>
              <div className='img_option_container'>
                  <div
                      className={fillAddBsk ? 'menu_item_img active' : 'menu_item_img'}
                      alt='Item Image'
                      style={{
                          backgroundImage: `url(${getImageUrl(item)})`,
                          backgroundSize: 'cover',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                      }}>
                  </div>
                  <ClipLoader
                      color={'#001e00'}
                      loading={true}
                      cssOverride={override}
                      size={150}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                  />
                  <button className='item_option_btn' onClick={() => {
                      window.scroll(0, 0);
                      navigate('/market/' + catHandle + '/' + item.handle)
                  }}>ITEM DETAILS
                  </button>
                  <button className={fillAddBsk ? 'item_option_btn inactive_2 active ' : 'item_option_btn'}
                          onClick={() => {
                            if (selectedVariant) { // Ensure selectedVariant is set
                                onAddToBasket(1, selectedVariant.id);
                                setFillAddBsk(true);
                                setTimeout(() => {
                                    setFillAddBsk(false);
                                }, 1000);
                            }
                          }}
                  ><ClipLoader
                      color={'#fff'}
                      loading={fillAddBsk}
                      cssOverride={overrideSmall}
                      size={'50px'}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                  />ADD TO BASKET
                  </button>

              </div>
              <div className='menu_item_info'>
                  <h3 className='menu_item_name'>{item.title.toUpperCase()}</h3>
                  <div className='menu_item_details_container'>

                      <div className='icon_txt_container' style={{margin: "3px 0 5px 0"}}>
                          {isLoading ? (
                              <ClipLoader
                                  color={'#001e00'}
                                  loading={true}
                                  cssOverride={overrideSmallest}
                                  size={'50px'}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                              />
                          ) : (
                              variants.length !== 0 && (
                                  <>
                                      <img
                                          className={'menu_item_icon'}
                                          alt='Group Icon'
                                          src={require('./../../images/icon-group.png')}
                                          loading="eager"
                                          style={{margin: "2px 0 0 0"}}
                                      />
                                      {variants.length === 1 ?
                                          <span className='menu_item_notice'>{selectedVariant.servings} servings</span>
                                          :
                                          <ServingsDropdown variants={variants} selectedVariant={selectedVariant} handleVariantChange={handleVariantChange}/>
                                      }
                                  </>
                              )
                          )}
                      </div>

                      <div className="break"></div>
                      <div className='icon_txt_container' style={{margin: "5px 0 10px 0"}}>
                          <img
                              className={'menu_item_icon'}
                              alt='Calendar Icon'
                              src={require('./../../images/icon-calendar.png')}
                              loading="eager"
                          />
                          <span className='menu_item_notice'>
                            {item.metafields.find(field => field?.key === "days_notice")?.value + ' days notice'}
                          </span>
                      </div>
                  </div>
                  <div className='price_add_bsk_container'>
                      <h2 className='menu_item_price'>£{selectedVariant?.price?.toFixed(2) || "-"}</h2>
                      <button className={fillAddBskSml ? 'item_option_btn_small vanish' : 'item_option_btn_small'}
                              onClick={() => {
                                if (selectedVariant) { // Ensure selectedVariant is set
                                    onAddToBasket(1, selectedVariant.id);
                                    setFillAddBskSml(true);
                                    setTimeout(() => {
                                        setFillAddBskSml(false);
                                    }, 1000);
                                }
                              }}>
                          <img
                              className={fillAddBskSml ? 'basket_icon_add vanish' : 'basket_icon_add'}
                              alt='Basket Icon'
                              src={require('./../../images/basket_icon_green.png')}
                              loading="eager"
                          />
                          <span className={fillAddBskSml ? 'basket_plus vanish' : 'basket_plus'}>+</span>
                          <ClipLoader
                              color={'#001e00'}
                              loading={fillAddBskSml}
                              cssOverride={overrideSmaller}
                              size={'50px'}
                              aria-label="Loading Spinner"
                              data-testid="loader"
                          />
                      </button>
                  </div>
              </div>
          </li>
      </Zoom>
  )
}

export default MarketMenuItem
